// Status codes from the Incode SDK that indicate a deliberate biometric/security
// failure — retrying with AWS for these would give an impostor a second attempt.
// Source: IncodeFaceLoginStatuses.php (persons-api codebase). Shared between the
// SDK 1.x and 2.0 engine components so both stay in sync with the PHP contract.
export const INCODE_BIOMETRIC_FAILURE_STATUSES = [4004, 4005];

// String error codes from the Incode SDK that indicate a user-exhausted or
// deliberate outcome — not a connection/technical failure, so no AWS retry.
export const INCODE_NON_RETRIABLE_CODES = ['NO_MORE_ATTEMPTS'];

// SDK 2.0's createAuthenticationManager surfaces a string `moduleErrorCode`
// (FACE_ERROR_CODES in @incodetech/core) instead of the numeric HTTP-style
// statuses above. 'NO_MORE_ATTEMPTS' is verified identical in both SDKs.
export const INCODE_V2_NON_RETRIABLE_CODES = ['NO_MORE_ATTEMPTS'];

// Verified against @incodetech/core@2.2.0 authenticationStateMachine
// (AUTH_ERROR_MAP + Incode's own vue-face-auth-sdk-2 reference): these are
// terminal biometric/identity failures where an AWS retry would help an
// impostor, not a user with a bad connection.
export const INCODE_V2_BIOMETRIC_FAILURE_CODES = [
  'USER_IS_NOT_RECOGNIZED',
  'SPOOF_ATTEMPT_DETECTED',
  'NONEXISTENT_CUSTOMER',
  'HINT_NOT_PROVIDED',
];
